import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCamera2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-2, picture, image, cam"><path fillRule="evenodd" clipRule="evenodd" d="M8.12666 5C8.98667 3.79079 10.4006 3 12 3C13.5994 3 15.0133 3.79079 15.8733 5H18.25C20.3211 5 22 6.67893 22 8.75V17.25C22 19.3211 20.3211 21 18.25 21H5.75C3.67893 21 2 19.3211 2 17.25V8.75C2 6.67893 3.67893 5 5.75 5H8.12666ZM12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCamera2;
